"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiRequest = exports.apiPut = exports.apiPost = exports.apiPatch = exports.apiGet = exports.apiDelete = void 0;
function apiDelete(client, path, params = {}, headers = {}) {
    return apiRequest(client, path, params, headers, 'delete');
}
exports.apiDelete = apiDelete;
function apiGet(client, path, params = {}, headers = {}) {
    return apiRequest(client, path, params, headers, 'get');
}
exports.apiGet = apiGet;
function apiPatch(client, path, params = {}, headers = {}) {
    return apiRequest(client, path, params, headers, 'patch');
}
exports.apiPatch = apiPatch;
function apiPost(client, path, params = {}, headers = {}) {
    return apiRequest(client, path, params, headers, 'post');
}
exports.apiPost = apiPost;
function apiPut(client, path, params = {}, headers = {}) {
    return apiRequest(client, path, params, headers, 'put');
}
exports.apiPut = apiPut;
async function apiRequest(client, path, params = {}, headers = {}, method = 'get') {
    const axiosMethod = method.toLowerCase();
    let response;
    switch (axiosMethod) {
        case 'delete':
        case 'get':
        case 'head':
        case 'options':
            response = await client[axiosMethod](path, { params, headers });
            break;
        case 'patch':
        case 'post':
        case 'put':
            response = await client[axiosMethod](path, params, { headers });
            break;
        default:
            throw new Error(`Invalid HTTP method '${axiosMethod}'`);
    }
    return {
        data: response.data,
        status: response.status,
        headers: response.headers,
    };
}
exports.apiRequest = apiRequest;
//# sourceMappingURL=api.js.map